import { LevelData } from '../level-data';

export const level17: LevelData = {
    name: 'Chaos',
    timeLimit: 110,
    track: [
        '-------',
        '-------',
        '---B---',
        '-------',
        '--   --',
        '-------',
        '---B---',
        '-------',
        '  ---  ',
        '-------',
        '---S---',
        '-------',
        '--   --',
        '-------',
        '---B---',
        '-------',
        '  ---  ',
        '-------',
        '--   --',
        '-------',
        '---B---',
        '-------',
        '-------',
        '       ',
        '       ',
        '-------',
        '-------',
        '--   --',
        '-------',
        '---B---',
        '-------',
        '  ---  ',
        '-------',
        '---S---',
        '-------',
        '--   --',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        'FFFFFFF',
    ],
};
